import React from "react";
import { useParams } from "react-router-dom";
import AboutBanner from "../AboutUs/AboutBanner";

// আলাদা কোম্পানির কম্পোনেন্টগুলো ইম্পোর্ট করুন
import ExpressAbout from "./ExpressAbout/ExpressAbout";
import GreenlandAbout from "./GreenlandAbout/GreenlandAbout";
import DigitalAbout from "./DigitalAbout/DigitalAbout";
import SoftAbout from "./SoftAbout/SoftAbout";
import BdIconicAbout from "./BdIconicAbout/BdIconicAbout";
import FurnitureAbout from "./FurnitureAbout/FurnitureAbout";
import GlobalTravelsAbout from "./GlobalTravelsAbout/GlobalTravelsAbout";
import MotorsAbout from "./MotorsAbout/MotorsAbout";
import TransportAbout from "./TransportAbout/TransportAbout";
import TrackerAbout from "./TrackerAbout/TrackerAbout";
import HolidaysAbout from "./HolidaysAbout/HolidaysAbout";
import ShikhonAbout from "./ShikhonAbout/ShikhonAbout";
import HajjGroupAbout from "./HajjGroupAbout/HajjGroupAbout";

const companyData = {
  express: {
    title: "Iconic Express",
    component: ExpressAbout,
  },
  greenland: {
    title: "Iconic Greenland",
    component: GreenlandAbout,
  },
  "global-travels": {
    title: "Iconic Global Travels",
    component: GlobalTravelsAbout,
  },
  furniture: {
    title: "Iconic Furniture",
    component: FurnitureAbout,
  },
  motors: {
    title: "Iconic Motors",
    component: MotorsAbout,
  },
  soft: {
    title: "Iconic Soft",
    component: SoftAbout,
  },
  digital: {
    title: "Iconic Digital Solutions",
    component: DigitalAbout,
  },
  transport: {
    title: "Iconic Transport",
    component: TransportAbout,
  },
  bdiconic: {
    title: "BD Iconic Company",
    component: BdIconicAbout,
  },
  tracker: {
    title: "Iconic Tracker",
    component: TrackerAbout,
  },
  holidays: {
    title: "Iconic Holidays",
    component: HolidaysAbout,
  },
  shikhon: {
    title: "Iconic Shikhon",
    component: ShikhonAbout,
  },
  hajj: {
    title: "Iconic Hajj Group",
    component: HajjGroupAbout,
  },
};

const CompanyInfoDetails = () => {
  const { id } = useParams();
  const companyId = (id || "").toLowerCase();
  const companyInfo = companyData[companyId];
  const SelectedCompanyComponent = companyInfo?.component;
  const bannerTitle =
    companyInfo?.title || companyId.replace(/-/g, " ").toUpperCase();

  return (
    <div>
      <AboutBanner text={bannerTitle} des="Details About Company" />

      {SelectedCompanyComponent ? (
        <SelectedCompanyComponent />
      ) : (
        <div style={{ padding: "40px", textAlign: "center" }}>
          <h2>Company Details Not Found</h2>
        </div>
      )}
    </div>
  );
};

export default CompanyInfoDetails;
